export default function axiosRetry(axios, {
  retries = 3,
  retryCondition = error => !error.response
} = {}) {
  axios.interceptors.response.use(response => {
    const config = response.config;

    config.retryCount = config.retryCount || 0;

    const shouldRetry =
      retryCondition(response)
      && config.retryCount < retries;

    if (shouldRetry) {
      config.retryCount++;

      if (axios.defaults.agent === config.agent) {
        delete config.agent;
      }
      if (axios.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
      }
      if (axios.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
      }

      return axios(config);
    } else if (retryCondition(response) && config.retryCount === retries) {
      return Promise.reject(new Error('Bad response after multiple retries'));
    }

    return Promise.resolve(response);
  });
}



// WEBPACK FOOTER //
// ./helpers/retry.helper.js